import { useTranslation } from 'react-i18next';
import { NavItem } from 'src/components/Buttons/NavItem';
import { Users } from 'lucide-react';
import { OrganizationRolePermission } from 'src/domain/organization';
import { isOrganizationAdministrator } from 'src/domain/user';
import { useCreatorRolePermission } from 'src/view/hooks/useCreatorRolePermission';
import { useSignedInUser } from 'src/view/hooks/useSignedInUser';

export const LinkToCreators = () => {
    const user = useSignedInUser();
    const { t } = useTranslation();
    const canReadEmployees = useCreatorRolePermission(
        OrganizationRolePermission.readEmployees,
        { scope: 'any', allowOrganization: false },
    );

    if (!isOrganizationAdministrator(user) && !canReadEmployees) return null;

    return (
        <NavItem
            icon={Users}
            label={t('modules.creators.navLabel')}
            screen="/app/creators"
            indentChildren={false}
        />
    );
};
